<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        @back="back"
        title
        :content="$t('transferir-cliente-licenca')"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-position="top"
      >
        <el-form-item >
          <el-radio-group v-model="ruleForm.main" @change="fetchRecords()">
            <el-radio label="1" key="1">{{
              $t("clientes-licenca")
            }}</el-radio>
            <el-radio label="2" key="2">{{ $t("clientes-matriz") }}</el-radio>
            <el-radio label="3" key="3">{{ $t("licenca-matriz") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('licenca-origem')" prop="source" v-show="ruleForm.main == '1'">
          <CustomerList
            v-model="ruleForm.source"
            v-bind:customerType="2"
            v-bind:current="ruleForm.source"
          />
        </el-form-item>
        <el-form-item :label="ruleForm.main == '1' ? $t('para') : ruleForm.main == '3' ? $t('licenca-origem') : $t('licenca-destino')" prop="destiny">
          <CustomerList
            v-model="ruleForm.destiny"
            v-bind:customerType="2"
            v-bind:current="ruleForm.destiny"
            v-on:selected="fetchRecords"
          />
        </el-form-item>
        <el-form-item :label="$t('pesquisar')" prop="search">
          <el-input v-model="ruleForm.filter" />
        </el-form-item>
        <el-table
          :data="listCustomers.filter(
            (data) =>
              !ruleForm.filter ||
              data.zipcode.zipcode.toLowerCase().includes(ruleForm.filter.toLowerCase()) ||
              data.companyname
                .toLowerCase()
                .includes(ruleForm.filter.toLowerCase()) ||
              data.zipcode.address.toLowerCase().includes(ruleForm.filter.toLowerCase())
          )"
          stripe
          ref="tableCustomers"
          style="width: 100%"
          :default-sort="{ prop: 'name', order: 'ascending' }"
        >
          <el-table-column type="selection" width="80"></el-table-column>
          <el-table-column
            sortable
            prop="companyname"
            :label="$t('cliente')"
          >
          </el-table-column>
          <el-table-column
            sortable
            prop="zipcode"
            width="120"
            :label="$t('cep')"
          >
            <template slot-scope="scope">
              {{ scope.row.zipcode.zipcode }}
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="address"
            :label="$t('endereco')"
          >
            <template slot-scope="scope">
              {{ scope.row.zipcode.address }}
            </template>
          </el-table-column>
        </el-table>
        <br />
        <el-form-item style="text-align: center">
          <el-button
            type="warning"
            autofocus
            @click="submitForm('ruleForm')"
            >{{ $t("transferir") }}</el-button
          >
          <el-button type="danger" @click="back()">{{
            $t("voltar")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { CustomerService } from "@/services/customers/customers.services";
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";

import { i18n } from "@/plugin/i18n";

export default {
  name: "CustomerTransfer",
  components: {
    CustomerList,
  },
  data() {
    return {
      user: {
        type: '2',
      },
      listCustomers: [],
      ruleForm: {
        source: "",
        destiny: "",
        main: '1',
        filter: '',
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.replace({ name: "customer" });
    },
    fetchRecords() {
      const vm = this;
      vm.listCustomers = [];
      console.log('main', vm.ruleForm.main, vm.ruleForm.destiny)
      if (vm.ruleForm.main === '2') {
        const loading = vm.$loading(vm.$options.loading);
        CustomerService.list(99999999, 1, '1')
        .then((response) => {
            vm.listCustomers = response.records;
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
              duration: 5000,
            });
          })
          .finally(() => loading.close());

      } else if (vm.ruleForm.main === '3' && vm.ruleForm.destiny) {
        const loading = vm.$loading(vm.$options.loading);
        CustomerService.license(vm.ruleForm.destiny)
          .then((response) => {
            vm.listCustomers = response.records;
            this.$refs.tableCustomers.toggleAllSelection()
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
              duration: 5000,
            });
          })
          .finally(() => loading.close());

      } else if (vm.ruleForm.source) {
        const loading = vm.$loading(vm.$options.loading);
        CustomerService.license(vm.ruleForm.source)
          .then((response) => {
            vm.listCustomers = response.records;
            this.$refs.tableCustomers.toggleAllSelection()
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
              duration: 5000,
            });
          })
          .finally(() => loading.close());
      }
    },
    submitForm(formName) {
      const vm = this;
      if (vm.$refs.tableCustomers.selection.length === 0) {
        return this.$message({
          type: "error",
          message: "É preciso selecionar ao menos um cliente para transferência!",
          duration: 5000,
        });
      }

      if (vm.ruleForm.main == '3' && !vm.ruleForm.destiny) {
        return this.$message({
          type: "error",
          message: "É preciso informar a licença de origem",
          duration: 5000,
        });
      } else if (vm.ruleForm.main == '1' && !vm.ruleForm.source) {
        return this.$message({
          type: "error",
          message: "É preciso informar a licença de origem",
          duration: 5000,
        });
      } else if (vm.ruleForm.main == '1' && (!vm.ruleForm.source || !vm.ruleForm.destiny)) {
        return this.$message({
          type: "error",
          message: "É preciso informar a licença de origem e destino",
          duration: 5000,
        });
      } else if (vm.ruleForm.main == '2' && !vm.ruleForm.destiny) {
        return this.$message({
          type: "error",
          message: "É preciso informar a licença de destino",
          duration: 5000,
        });
      }
      if (vm.ruleForm.source === vm.ruleForm.destiny) {
        return this.$message({
          type: "error",
          message: "A licença de origem e destino é a mesma!",
          duration: 5000,
        });
      }
      const loading = vm.$loading(vm.$options.loading);
      CustomerService.transfer(
        vm.ruleForm.destiny,
        { 
          action: vm.ruleForm.main,
          list: vm.$refs.tableCustomers.selection.map(x => {
            return x.id;
          })
        }
      )
        .then((response) => {
          this.$message({
            type: "success",
            message: i18n.tc("clientes-transferidos-com-sucesso"),
            duration: 5000,
          });
          vm.fetchRecords();
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
            duration: 5000,
          });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((user) => {
        vm.user = user;
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}
@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>

